import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './Footer.css';
import DiscordButton from './components/DiscordButton';
import RedditButton from './components/RedditButton';
import poweredByStravaLogo from './assets/strava/api_logo_pwrdBy_strava_horiz_black.svg';

function Footer() {
    const { t } = useTranslation();
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-section">
                    <div className="footer-brand">
                        <Link to="/" className="footer-logo">Mythic Maps</Link>
                        <p className="footer-description">
                            {t('footer.tagline')}
                        </p>
                    </div>
                </div>
                
                <div className="footer-section">
                    <h4>{t('footer.legal')}</h4>
                    <ul className="footer-links">
                        <li><Link to="/privacy-policy">{t('footer.privacyPolicy')}</Link></li>
                        <li><Link to="/cookie-policy">{t('footer.cookiePolicy')}</Link></li>
                        <li><Link to="/terms-of-service">{t('footer.termsOfService')}</Link></li>
                    </ul>
                </div>
                
                <div className="footer-section">
                    <h4>{t('footer.community')}</h4>
                    <ul className="footer-links">
                        <li><DiscordButton /></li>
                        <li><RedditButton /></li>
                    </ul>
                </div>
            </div>
            
            <div className="footer-bottom">
                <div className="footer-bottom-content">
                    <p>© 2025 Mythic Maps. {t('footer.rightsReserved')}</p>
                    <div className="strava-attribution">
                        <img src={poweredByStravaLogo} alt="Powered by Strava" className="strava-logo" />
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer; 